import combosActionTypes from '../../constants/actions/combos/combos'
import {estado} from '../../constants/estado'
import {estadoVerraco} from '../../constants/estadoVerraco'
import movimientoVerracoActionTypes from '../../constants/actions/movimientoVerraco/movimientoVerraco'
import {causaEliminado} from '../../constants/causasEliminado'
import {analisisExtraccion, translateAnalisisExtraccion, tipoAnalisisExtraccion, translateTipoAnalisisExtraccion, observacionesEyaculadoEliminado, translateObservacionesEyaculadoEliminado} from '../../constants/analisis'
import {tipoAccionBioseguridadHigiene, translateTipoAccionBioseguridadHigiene, tipoOtros, translateTipoOtros, estadoAccion, translateEstadoAccion} from '../../constants/tipoAccion'
import {estadoDilucion, translateEstadoDilucion} from '../../constants/estadoDilucion'
import {estadoEnvasado, translateEstadoEnvasado} from '../../constants/estadoEnvasado'
import {tratamiento, translatetratamiento} from '../../constants/tratamiento'
import {verracoSiNo, translateVerracoSiNo, tipoControlSeguimiento, translateTipoControlSeguimiento} from '../../constants/seguimiento'
import {estadoAlbaran, translateEstadoAlbaran} from '../../constants/albaran'
import {modulos, translateModulos} from '../../constants/modulos'
import {tipoTareasAgenda, translateTipoTareasAgenda, colorTipoTareasAgenda} from '../../constants/agenda'

export function initialState () {  
  return {
    comboCodLineaGenetica: [],
    comboLineaGenetica: [],
    comboEstado: [
      {value: estado.ACTIVO, label: 'COMUN.COMBOS.COMBO_ESTADO.ACTIVO'},
      {value: estado.INACTIVO, label: 'COMUN.COMBOS.COMBO_ESTADO.INACTIVO'}
    ],
    comboCodRaza: [],
    comboRaza: [],
    comboNombreGrupoVerraco: [],
    comboVerraco: [],
    comboTipoInstalacionPadre: [],
    comboTipoInstalacion: [],
    comboInstalacionPadre: [],
    comboCodInstalacion: [],
    comboNombreInstalacion: [],
    comboOperario: [],
    comboSalaExtraccion: [],
    comboEstadoVerraco: [
      {value: estadoVerraco.CUARENTENA, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.CUARENTENA'},
      {value: estadoVerraco.PRESENTADO, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.PRESENTE'},
      {value: estadoVerraco.ACTIVO, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO'},
      {value: estadoVerraco.ENFERMO, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.ENFERMO'},
      {value: estadoVerraco.BAJA, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.BAJA'},
      {value: estadoVerraco.MUERTO, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.MUERTO'}

    ],
    comboEstadoVerracoNoEliminado: [
      {value: estadoVerraco.CUARENTENA, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.CUARENTENA'},
      {value: estadoVerraco.PRESENTADO, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.PRESENTE'},
      {value: estadoVerraco.ACTIVO, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO'},
      {value: estadoVerraco.ENFERMO, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.ENFERMO'}
    ],
    comboTipoDosis: [],
    comboUbicacion: [],
    comboUbicacionVacia: [],
    comboObtenerCentroUsuario: [],
    comboTiempoMonta: [
      { value: 1, label: 'COMUN.COMBOS.TIEMPO_MONTA.MUY_LENTO' },
      { value: 2, label: 'COMUN.COMBOS.TIEMPO_MONTA.LENTO' },
      { value: 3, label: 'COMUN.COMBOS.TIEMPO_MONTA.NORMAL' },
      { value: 4, label: 'COMUN.COMBOS.TIEMPO_MONTA.RAPIDO' },
      { value: 5, label: 'COMUN.COMBOS.TIEMPO_MONTA.MUY_RAPIDO' }
    ],
    comboConservacion: [
      { value: 1, label: '*' },
      { value: 2, label: '**' },
      { value: 3, label: '***' },
      { value: 4, label: '****' },
      { value: 5, label: '*****' }
    ],
    comboCausaEliminacion: [
      // {value: causaEliminado.MUERTE_SUBITA, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.MUERTE_SUBITA'},
      // {value: causaEliminado.RECLAMACION, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.RECLAMACION'},
      // {value: causaEliminado.FORMAS_ANORMALES, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.FORMAS_ANORMALES'},
      // {value: causaEliminado.CONSERVACION_DOSIS, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.CONSERVACION_DOSIS'},
      // {value: causaEliminado.PROGRESO_GENETICO, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.PROGRESO_GENETICO'},
      // {value: causaEliminado.FALTA_DEMANDA, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.FALTA_DEMANDA'},
      // {value: causaEliminado.PROBLEMAS_LOCOMOTORES, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.PROBLEMAS_LOCOMOTORES'},
      // {value: causaEliminado.PROBLEMAS_SALUD, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.PROBLEMAS_SALUD'},
      // {value: causaEliminado.ANALITICAS, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.ANALITICAS'},
      // {value: causaEliminado.OTRAS, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.OTRAS'},
      // {value: causaEliminado.EDAD, label: 'COMUN.COMBOS.CAUSA_ELIMINACION.EDAD'}
    ],
    comboListadoVerracos: [],
    comboPool: [],
    comboAnalisisExtraccion: [
      {value: analisisExtraccion.TODOS, label: translateAnalisisExtraccion[analisisExtraccion.TODOS], predeterminado: true},
      {value: analisisExtraccion.PREVISTO, label: translateAnalisisExtraccion[analisisExtraccion.PREVISTO]}
    ],
    comboTipoAnalisisExtraccion: [
      {value: tipoAnalisisExtraccion.COLORIMETRO, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.COLORIMETRO]},
      {value: tipoAnalisisExtraccion.CAMARA_BURKER, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.CAMARA_BURKER]},
      {value: tipoAnalisisExtraccion.MAGAVISION_I, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.MAGAVISION_I]},
      {value: tipoAnalisisExtraccion.MAGAVISION_M, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.MAGAVISION_M]},
      {value: tipoAnalisisExtraccion.NUEVO_MAGAVISION, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.NUEVO_MAGAVISION]},
      {value: tipoAnalisisExtraccion.MAGAVISION_ML, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.MAGAVISION_ML]},
      {value: tipoAnalisisExtraccion.CAMARA_NEUBAUER, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.CAMARA_NEUBAUER]}
    ],
    comboObservacionesEyaculadoEliminado: [
      // {value: observacionesEyaculadoEliminado.PROBLEMAS_ENTRENAMIENTO, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.PROBLEMAS_ENTRENAMIENTO]},
      // {value: observacionesEyaculadoEliminado.AGOTAMIENTO, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.AGOTAMIENTO]},
      // {value: observacionesEyaculadoEliminado.EXCEDENTE_MACHO_ERRONEO, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.EXCEDENTE_MACHO_ERRONEO]},
      // {value: observacionesEyaculadoEliminado.BAJA_MOTILIDAD, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.BAJA_MOTILIDAD]},
      // {value: observacionesEyaculadoEliminado.BAJA_CONCENTRACION, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.BAJA_CONCENTRACION]},
      // {value: observacionesEyaculadoEliminado.ALTA_MORFOLOGIA, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.ALTA_MORFOLOGIA]},
      // {value: observacionesEyaculadoEliminado.ALTA_AGLUTINACION, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.ALTA_AGLUTINACION]},
      // {value: observacionesEyaculadoEliminado.ORINA, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.ORINA]},
      // {value: observacionesEyaculadoEliminado.SANGRE, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.SANGRE]},
      // {value: observacionesEyaculadoEliminado.PUS, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.PUS]},
      // {value: observacionesEyaculadoEliminado.OTROS, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.OTROS]},
      // {value: observacionesEyaculadoEliminado.CONTAMINACION, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.CONTAMINACION]},
      // {value: observacionesEyaculadoEliminado.SEMEN_MUERTO, label: translateObservacionesEyaculadoEliminado[observacionesEyaculadoEliminado.SEMEN_MUERTO]}
    ],
    comboTipoAnalisisPanelControl: [
      {value: tipoAnalisisExtraccion.COLORIMETRO, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.COLORIMETRO]},
      {value: tipoAnalisisExtraccion.CAMARA_BURKER, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.CAMARA_BURKER]},
      {value: tipoAnalisisExtraccion.MAGAVISION_I, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.MAGAVISION_I]},
      {value: tipoAnalisisExtraccion.MAGAVISION_M, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.MAGAVISION_M]},
      {value: tipoAnalisisExtraccion.NUEVO_MAGAVISION, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.NUEVO_MAGAVISION]},
      {value: tipoAnalisisExtraccion.MAGAVISION_ML, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.MAGAVISION_ML]},
      {value: tipoAnalisisExtraccion.CAMARA_NEUBAUER, label: translateTipoAnalisisExtraccion[tipoAnalisisExtraccion.CAMARA_NEUBAUER]}
    ],
    comboRectaCalibrado: [],
    comboTipoDiluyente: [],
    comboDispositivosVideo: [],
    comboProducto: [],
    comboTipoAlimentacion: [],
    comboTipoIntervencionSanitaria: [],
    comboVerracoSinUbicacion: [],
    comboTipoAccion: [
      {value: tipoAccionBioseguridadHigiene.ANALITICA_AGUA, label: translateTipoAccionBioseguridadHigiene[tipoAccionBioseguridadHigiene.ANALITICA_AGUA]},
      {value: tipoAccionBioseguridadHigiene.LIMPIEZA_SILO_DEPOSITO, label: translateTipoAccionBioseguridadHigiene[tipoAccionBioseguridadHigiene.LIMPIEZA_SILO_DEPOSITO]},
      {value: tipoAccionBioseguridadHigiene.LIMPIEZA_CORRALES, label: translateTipoAccionBioseguridadHigiene[tipoAccionBioseguridadHigiene.LIMPIEZA_CORRALES]},
      {value: tipoAccionBioseguridadHigiene.OTROS, label: translateTipoAccionBioseguridadHigiene[tipoAccionBioseguridadHigiene.OTROS]}
    ],
    comboTipoOtros: [
      {value: tipoOtros.UBICACION, label: translateTipoOtros[tipoOtros.UBICACION]},
      {value: tipoOtros.VERRACO, label: translateTipoOtros[tipoOtros.VERRACO]},
      {value: tipoOtros.GRUPO_VERRACO, label: translateTipoOtros[tipoOtros.GRUPO_VERRACO]}
    ],
    comboEstadoAccion: [
      {value: estadoAccion.NO, label: translateEstadoAccion[estadoAccion.NO]},
      {value: estadoAccion.SI, label: translateEstadoAccion[estadoAccion.SI]},
      {value: estadoAccion.PENDIENTE, label: translateEstadoAccion[estadoAccion.PENDIENTE]},
      {value: estadoAccion.DEBE_MEJORAR, label: translateEstadoAccion[estadoAccion.DEBE_MEJORAR]}
    ],
    comboMaquina: [],
    comboDiluido: [
      {value: estadoDilucion.DILUIDO, label: translateEstadoDilucion[estadoDilucion.DILUIDO]},
      {value: estadoDilucion.NO_DILUIDO, label: translateEstadoDilucion[estadoDilucion.NO_DILUIDO]}
    ],
    comboEnvasado: [
      {value: estadoEnvasado.ENVASADO, label: translateEstadoEnvasado[estadoEnvasado.ENVASADO]},
      {value: estadoEnvasado.NO_ENVASADO, label: translateEstadoEnvasado[estadoEnvasado.NO_ENVASADO]}
    ],
    comboRuta: [],
    comboCliente: [],
    comboCifCliente: [],
    comboDireccionCliente: [],
    comboDireccionClienteSecundaria: [],
    comboLocalidadCliente: [],
    comboInstalacionesPadre: [],
    comboNombresOperarios: [],
    comboApellidosOperarios: [],
    comboLocalidadOperarios: [],
    comboEmpresaVisitas: [],
    comboContactoVistas: [],
    comboLineaGeneticaActiva: [],
    comboRazaActiva: [],
    comboOperarioActivo: [],
    comboSalaExtraccionActivo: [],
    comboTratamiento:[
      {value: tratamiento.SI, label: translatetratamiento[tratamiento.SI]},
      {value: tratamiento.NO, label: translatetratamiento[tratamiento.NO]}
    ],
    comboEmpresaTransportista: [],
    comboConductoresTransportista: [],
    comboVehiculosTransportista: [],
    comboGenHalotano: [
      {value: 'NN', label: 'NN'},
      {value: 'NP', label: 'NP'},
      {value: 'PP', label: 'PP'}
    ],
    comboUsuariosCentro: [],
    comboGrupoUsuariosCentro: [],
    comboNombreProductos: [],
    comboReferenciaProductos: [],
    comboProductoEscandallo: [],
    comboProveedoresEntradaMercancia: [],
    comboAlbaranesEntradaMercancia: [],
    comboOrigenesEntradaMercancia: [],
    comboLotes: [],
    comboLotesActivos: [],
    comboProductosActivos: [],
    comboProductosActivosTrazabilidad: [],
    comboLotesProductoEspecificoActivo: [],
    comboLotesProductoEspecificoActivoTrazabilidad: [],
    comboVerracoSiNo: [
      {value: verracoSiNo.VERRACO, label: translateVerracoSiNo[verracoSiNo.VERRACO]},
      {value: verracoSiNo.POOL, label: translateVerracoSiNo[verracoSiNo.POOL]}
    ],
    comboTipoControlSeguimiento: [
      {value: tipoControlSeguimiento.INTERNO, label: translateTipoControlSeguimiento[tipoControlSeguimiento.INTERNO], predeterminado: true},
      {value: tipoControlSeguimiento.EXTERNO, label: translateTipoControlSeguimiento[tipoControlSeguimiento.EXTERNO]},
      {value: tipoControlSeguimiento.ACROSOMAS, label: translateTipoControlSeguimiento[tipoControlSeguimiento.ACROSOMAS]}
    ],
    comboRazonSocialClientesActivos: [],
    comboAliasClientesActivos: [],
    comboIndex: [],
    comboUbicacionPadre: [],
    comboEstadoPlaning: [
      {value: 1, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.CUARENTENA'},
      {value: 2, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.PRESENTE'},
      {value: 3, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO'},
      {value: 4, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.ENFERMO'},
      {value: 5, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.BAJA'}
    ],
    comboEstadoModalSugerenciasPlaning: [
      {value: 2, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.PRESENTE'},
      {value: 3, label: 'COMUN.COMBOS.COMBO_ESTADO_VERRACO.ACTIVO'}
    ],
    comboVerracosPresentesActivos: [],
    comboEstadoAlbaran: [
      {value: estadoAlbaran.BORRADOR, label: translateEstadoAlbaran[estadoAlbaran.BORRADOR]},
      {value: estadoAlbaran.CANCELADO, label: translateEstadoAlbaran[estadoAlbaran.CANCELADO]},
      {value: estadoAlbaran.REALIZADO, label: translateEstadoAlbaran[estadoAlbaran.REALIZADO]}
    ],
    comboVerracosExtraccionAlbaran: [],
    comboPoolsExtraccionAlbaran: [],
    comboClienteActivo: [],
    comboClienteSecundarioActivo: [],
    comboDireccionClienteActivo: [],
    comboClienteConVerracosEnPropiedad: [],
    comboEstadoPedido: [
      {value: 1, label: 'COMUN.COMBOS.COMBO_ESTADO_PEDIDO.BORRADOR'},
      {value: 2, label: 'COMUN.COMBOS.COMBO_ESTADO_PEDIDO.CANCELADO'},
      {value: 3, label: 'COMUN.COMBOS.COMBO_ESTADO_PEDIDO.CONFIRMADO'},
      {value: 4, label: 'COMUN.COMBOS.COMBO_ESTADO_PEDIDO.REALIZADO'}
    ],
    comboNumeroPedido: [],
    comboTransportistasCliente: [],
    comboRutaTransportistaCliente: [],
    comboVehiculosTransportistaDeterminado: [],
    comboConductoresTransportistaDeterminado: [],
    comboNumerosAlbaran: [],
    comboPropiedad: [
      { value: true, label: 'FICHA_VERRACO.NUEVO_VERRACO.COMBOS.PROPIO'},
      { value: false, label: 'FICHA_VERRACO.NUEVO_VERRACO.COMBOS.ALQUILADO'}
    ],
    comboEmpresaTransportistaActivos: [],
    comboInstalacionPadreActiva: [],
    comboFiltroVerracosLimpieza: [],
    comboLocalidadClientes: [],
    comboProvinciasClientes: [],
    comboUsuariosNoAsignadosOperario: [],
    comboOperarioPredeterminado: [],
    comboProductosValidacionActivos: [],
    comboTipoPerifericoConectividad: [
      {value: 1, label: 'COMUN.COMBOS.TIPO_PERIFERICO.MAQUINA_ENVASAR'},
      {value: 2, label: 'COMUN.COMBOS.TIPO_PERIFERICO.MAQUINA_DILUIR'},
      {value: 3, label: 'COMUN.COMBOS.TIPO_PERIFERICO.IMPRESORA'},
      {value: 4, label: 'COMUN.COMBOS.TIPO_PERIFERICO.BASCULA'},
      {value: 5, label: 'COMUN.COMBOS.TIPO_PERIFERICO.RFID_USB'},
      {value: 6, label: 'COMUN.COMBOS.TIPO_PERIFERICO.RFID_NETWORK'}
    ],
    comboTipoTareasAgenda: [
      {value: tipoTareasAgenda.CUARENTENA, label: translateTipoTareasAgenda[tipoTareasAgenda.CUARENTENA], ...colorTipoTareasAgenda[tipoTareasAgenda.CUARENTENA]},
      {value: tipoTareasAgenda.BIOSEGURIDAD_HIGIENE, label: translateTipoTareasAgenda[tipoTareasAgenda.BIOSEGURIDAD_HIGIENE], ...colorTipoTareasAgenda[tipoTareasAgenda.BIOSEGURIDAD_HIGIENE]},
      {value: tipoTareasAgenda.INTERVENCIONES_SANITARIAS, label: translateTipoTareasAgenda[tipoTareasAgenda.INTERVENCIONES_SANITARIAS], ...colorTipoTareasAgenda[tipoTareasAgenda.INTERVENCIONES_SANITARIAS]},
      {value: tipoTareasAgenda.COPIA_SEGURIDAD, label: translateTipoTareasAgenda[tipoTareasAgenda.COPIA_SEGURIDAD], ...colorTipoTareasAgenda[tipoTareasAgenda.COPIA_SEGURIDAD]},
      {value: tipoTareasAgenda.VIGILANCIA, label: translateTipoTareasAgenda[tipoTareasAgenda.VIGILANCIA], ...colorTipoTareasAgenda[tipoTareasAgenda.VIGILANCIA]}
    ],
    comboDiasAntes: [
      {value: 1, label: 1}, {value: 2, label: 2}, {value: 3, label: 3},
      {value: 4, label: 4}, {value: 5, label: 5}, {value: 6, label: 6},
      {value: 7, label: 7}, {value: 8, label: 8}, {value: 9, label: 9},
      {value: 10, label: 10}/*, {value: 11, label: 11}, {value: 12, label: 12},
      {value: 13, label: 13}, {value: 14, label: 14}, {value: 15, label: 15},
      {value: 16, label: 16}, {value: 17, label: 17}, {value: 18, label: 18},
      {value: 19, label: 19}, {value: 20, label: 20}, {value: 21, label: 21},
      {value: 22, label: 22}, {value: 23, label: 23}, {value: 24, label: 24},
      {value: 25, label: 25}, {value: 26, label: 26}, {value: 27, label: 27},
      {value: 28, label: 28}, {value: 29, label: 29}, {value: 30, label: 30},
      {value: 31, label: 31}*/
    ],
    comboMeses: [
      {value: 1, label: 'COMUN.DATE.MONTHS.ENERO'},
      {value: 2, label: 'COMUN.DATE.MONTHS.FEBRERO'},
      {value: 3, label: 'COMUN.DATE.MONTHS.MARZO'},
      {value: 4, label: 'COMUN.DATE.MONTHS.ABRIL'},
      {value: 5, label: 'COMUN.DATE.MONTHS.MAYO'},
      {value: 6, label: 'COMUN.DATE.MONTHS.JUNIO'},
      {value: 7, label: 'COMUN.DATE.MONTHS.JULIO'},
      {value: 8, label: 'COMUN.DATE.MONTHS.AGOSTO'},
      {value: 9, label: 'COMUN.DATE.MONTHS.SEPTIEMBRE'},
      {value: 10, label: 'COMUN.DATE.MONTHS.OCTUBRE'},
      {value: 11, label: 'COMUN.DATE.MONTHS.NOVIEMBRE'},
      {value: 12, label: 'COMUN.DATE.MONTHS.DICIEMBRE'}
    ],
    comboZonaHoraria: [
      {value: "International Date Line West (GMT-12:00)", label: "International Date Line West (GMT-12:00)"},
      {value: "American Samoa (GMT-11:00)", label: "American Samoa (GMT-11:00)"},
      {value: "Midway Island (GMT-11:00)", label: "Midway Island (GMT-11:00)"},
      {value: "Hawaii (GMT-10:00)", label: "Hawaii (GMT-10:00)"},
      {value: "Alaska (GMT-09:00)", label: "Alaska (GMT-09:00)"},
      {value: "Pacific Time (US &amp; Canada) (GMT-08:00)", label: "Pacific Time (US &amp; Canada) (GMT-08:00)"},
      {value: "Tijuana (GMT-08:00)", label: "Tijuana (GMT-08:00)"},
      {value: "Arizona (GMT-07:00)", label: "Arizona (GMT-07:00)"},
      {value: "Chihuahua (GMT-07:00)", label: "Chihuahua (GMT-07:00)"},
      {value: "Mazatlan (GMT-07:00)", label: "Mazatlan (GMT-07:00)"},
      {value: "Mountain Time (US &amp; Canada) (GMT-07:00)", label: "Mountain Time (US &amp; Canada) (GMT-07:00)"},
      {value: "Central America (GMT-06:00)", label: "Central America (GMT-06:00)"},
      {value: "Central Time (US &amp; Canada) (GMT-06:00)", label: "Central Time (US &amp; Canada) (GMT-06:00)"},
      {value: "Guadalajara (GMT-06:00)", label: "Guadalajara (GMT-06:00)"},
      {value: "Mexico City (GMT-06:00)", label: "Mexico City (GMT-06:00)"},
      {value: "Monterrey (GMT-06:00)", label: "Monterrey (GMT-06:00)"},
      {value: "Saskatchewan (GMT-06:00)", label: "Saskatchewan (GMT-06:00)"},
      {value: "Bogota (GMT-05:00)", label: "Bogota (GMT-05:00)"},
      {value: "Eastern Time (US &amp; Canada) (GMT-05:00)", label: "Eastern Time (US &amp; Canada) (GMT-05:00)"},
      {value: "Indiana (East) (GMT-05:00)", label: "Indiana (East) (GMT-05:00)"},
      {value: "Lima (GMT-05:00)", label: "Lima (GMT-05:00)"},
      {value: "Quito (GMT-05:00)", label: "Quito (GMT-05:00)"},
      {value: "Atlantic Time (Canada) (GMT-04:00)", label: "Atlantic Time (Canada) (GMT-04:00)"},
      {value: "Caracas (GMT-04:00)", label: "Caracas (GMT-04:00)"},
      {value: "Georgetown (GMT-04:00)", label: "Georgetown (GMT-04:00)"},
      {value: "La Paz (GMT-04:00)", label: "La Paz (GMT-04:00)"},
      {value: "Puerto Rico (GMT-04:00)", label: "Puerto Rico (GMT-04:00)"},
      {value: "Santiago (GMT-04:00)", label: "Santiago (GMT-04:00)"},
      {value: "Newfoundland (GMT-03:30)", label: "Newfoundland (GMT-03:30)"},
      {value: "Brasilia (GMT-03:00)", label: "Brasilia (GMT-03:00)"},
      {value: "Buenos Aires (GMT-03:00)", label: "Buenos Aires (GMT-03:00)"},
      {value: "Greenland (GMT-03:00)", label: "Greenland (GMT-03:00)"},
      {value: "Montevideo (GMT-03:00)", label: "Montevideo (GMT-03:00)"},
      {value: "Mid-Atlantic (GMT-02:00)", label: "Mid-Atlantic (GMT-02:00)"},
      {value: "Azores (GMT-01:00)", label: "Azores (GMT-01:00)"},
      {value: "Cape Verde Is. (GMT-01:00)", label: "Cape Verde Is. (GMT-01:00)"},
      {value: "Edinburgh (GMT+00:00)", label: "Edinburgh (GMT+00:00)"},
      {value: "Lisbon (GMT+00:00)", label: "Lisbon (GMT+00:00)"},
      {value: "London (GMT+00:00)", label: "London (GMT+00:00)"},
      {value: "Monrovia (GMT+00:00)", label: "Monrovia (GMT+00:00)"},
      {value: "UTC (GMT+00:00)", label: "UTC (GMT+00:00)"},
      {value: "Belgrade (GMT+01:00)", label: "Belgrade (GMT+01:00)"},
      {value: "Berlin (GMT+01:00)", label: "Berlin (GMT+01:00)"},
      {value: "Bern (GMT+01:00)", label: "Bern (GMT+01:00)"},
      {value: "Bratislava (GMT+01:00)", label: "Bratislava (GMT+01:00)"},
      {value: "Brussels (GMT+01:00)", label: "Brussels (GMT+01:00)"},
      {value: "Budapest (GMT+01:00)", label: "Budapest (GMT+01:00)"},
      {value: "Casablanca (GMT+01:00)", label: "Casablanca (GMT+01:00)"},
      {value: "Copenhagen (GMT+01:00)", label: "Copenhagen (GMT+01:00)"},
      {value: "Dublin (GMT+01:00)", label: "Dublin (GMT+01:00)"},
      {value: "Ljubljana (GMT+01:00)", label: "Ljubljana (GMT+01:00)"},
      {value: "Madrid (GMT+01:00)", label: "Madrid (GMT+01:00)"},
      {value: "Paris (GMT+01:00)", label: "Paris (GMT+01:00)"},
      {value: "Prague (GMT+01:00)", label: "Prague (GMT+01:00)"},
      {value: "Rome (GMT+01:00)", label: "Rome (GMT+01:00)"},
      {value: "Sarajevo (GMT+01:00)", label: "Sarajevo (GMT+01:00)"},
      {value: "Skopje (GMT+01:00)", label: "Skopje (GMT+01:00)"},
      {value: "Stockholm (GMT+01:00)", label: "Stockholm (GMT+01:00)"},
      {value: "Vienna (GMT+01:00)", label: "Vienna (GMT+01:00)"},
      {value: "Warsaw (GMT+01:00)", label: "Warsaw (GMT+01:00)"},
      {value: "West Central Africa (GMT+01:00)", label: "West Central Africa (GMT+01:00)"},
      {value: "Zagreb (GMT+01:00)", label: "Zagreb (GMT+01:00)"},
      {value: "Zurich (GMT+01:00)", label: "Zurich (GMT+01:00)"},
      {value: "Athens (GMT+02:00)", label: "Athens (GMT+02:00)"},
      {value: "Bucharest (GMT+02:00)", label: "Bucharest (GMT+02:00)"},
      {value: "Cairo (GMT+02:00)", label: "Cairo (GMT+02:00)"},
      {value: "Harare (GMT+02:00)", label: "Harare (GMT+02:00)"},
      {value: "Helsinki (GMT+02:00)", label: "Helsinki (GMT+02:00)"},
      {value: "Jerusalem (GMT+02:00)", label: "Jerusalem (GMT+02:00)"},
      {value: "Kaliningrad (GMT+02:00)", label: "Kaliningrad (GMT+02:00)"},
      {value: "Kyiv (GMT+02:00)", label: "Kyiv (GMT+02:00)"},
      {value: "Pretoria (GMT+02:00)", label: "Pretoria (GMT+02:00)"},
      {value: "Riga (GMT+02:00)", label: "Riga (GMT+02:00)"},
      {value: "Sofia (GMT+02:00)", label: "Sofia (GMT+02:00)"},
      {value: "Tallinn (GMT+02:00)", label: "Tallinn (GMT+02:00)"},
      {value: "Vilnius (GMT+02:00)", label: "Vilnius (GMT+02:00)"},
      {value: "Baghdad (GMT+03:00)", label: "Baghdad (GMT+03:00)"},
      {value: "Istanbul (GMT+03:00)", label: "Istanbul (GMT+03:00)"},
      {value: "Kuwait (GMT+03:00)", label: "Kuwait (GMT+03:00)"},
      {value: "Minsk (GMT+03:00)", label: "Minsk (GMT+03:00)"},
      {value: "Moscow (GMT+03:00)", label: "Moscow (GMT+03:00)"},
      {value: "Nairobi (GMT+03:00)", label: "Nairobi (GMT+03:00)"},
      {value: "Riyadh (GMT+03:00)", label: "Riyadh (GMT+03:00)"},
      {value: "St. Petersburg (GMT+03:00)", label: "St. Petersburg (GMT+03:00)"},
      {value: "Tehran (GMT+03:30)", label: "Tehran (GMT+03:30)"},
      {value: "Abu Dhabi (GMT+04:00)", label: "Abu Dhabi (GMT+04:00)"},
      {value: "Baku (GMT+04:00)", label: "Baku (GMT+04:00)"},
      {value: "Muscat (GMT+04:00)", label: "Muscat (GMT+04:00)"},
      {value: "Samara (GMT+04:00)", label: "Samara (GMT+04:00)"},
      {value: "Tbilisi (GMT+04:00)", label: "Tbilisi (GMT+04:00)"},
      {value: "Volgograd (GMT+04:00)", label: "Volgograd (GMT+04:00)"},
      {value: "Yerevan (GMT+04:00)", label: "Yerevan (GMT+04:00)"},
      {value: "Kabul (GMT+04:30)", label: "Kabul (GMT+04:30)"},
      {value: "Ekaterinburg (GMT+05:00)", label: "Ekaterinburg (GMT+05:00)"},
      {value: "Islamabad (GMT+05:00)", label: "Islamabad (GMT+05:00)"},
      {value: "Karachi (GMT+05:00)", label: "Karachi (GMT+05:00)"},
      {value: "Tashkent (GMT+05:00)", label: "Tashkent (GMT+05:00)"},
      {value: "Chennai (GMT+05:30)", label: "Chennai (GMT+05:30)"},
      {value: "Kolkata (GMT+05:30)", label: "Kolkata (GMT+05:30)"},
      {value: "Mumbai (GMT+05:30)", label: "Mumbai (GMT+05:30)"},
      {value: "New Delhi (GMT+05:30)", label: "New Delhi (GMT+05:30)"},
      {value: "Sri Jayawardenepura (GMT+05:30)", label: "Sri Jayawardenepura (GMT+05:30)"},
      {value: "Kathmandu (GMT+05:45)", label: "Kathmandu (GMT+05:45)"},
      {value: "Almaty (GMT+06:00)", label: "Almaty (GMT+06:00)"},
      {value: "Astana (GMT+06:00)", label: "Astana (GMT+06:00)"},
      {value: "Dhaka (GMT+06:00)", label: "Dhaka (GMT+06:00)"},
      {value: "Urumqi (GMT+06:00)", label: "Urumqi (GMT+06:00)"},
      {value: "Rangoon (GMT+06:30)", label: "Rangoon (GMT+06:30)"},
      {value: "Bangkok (GMT+07:00)", label: "Bangkok (GMT+07:00)"},
      {value: "Hanoi (GMT+07:00)", label: "Hanoi (GMT+07:00)"},
      {value: "Jakarta (GMT+07:00)", label: "Jakarta (GMT+07:00)"},
      {value: "Krasnoyarsk (GMT+07:00)", label: "Krasnoyarsk (GMT+07:00)"},
      {value: "Novosibirsk (GMT+07:00)", label: "Novosibirsk (GMT+07:00)"},
      {value: "Beijing (GMT+08:00)", label: "Beijing (GMT+08:00)"},
      {value: "Chongqing (GMT+08:00)", label: "Chongqing (GMT+08:00)"},
      {value: "Hong Kong (GMT+08:00)", label: "Hong Kong (GMT+08:00)"},
      {value: "Irkutsk (GMT+08:00)", label: "Irkutsk (GMT+08:00)"},
      {value: "Kuala Lumpur (GMT+08:00)", label: "Kuala Lumpur (GMT+08:00)"},
      {value: "Perth (GMT+08:00)", label: "Perth (GMT+08:00)"},
      {value: "Singapore (GMT+08:00)", label: "Singapore (GMT+08:00)"},
      {value: "Taipei (GMT+08:00)", label: "Taipei (GMT+08:00)"},
      {value: "Ulaanbaatar (GMT+08:00)", label: "Ulaanbaatar (GMT+08:00)"},
      {value: "Osaka (GMT+09:00)", label: "Osaka (GMT+09:00)"},
      {value: "Sapporo (GMT+09:00)", label: "Sapporo (GMT+09:00)"},
      {value: "Seoul (GMT+09:00)", label: "Seoul (GMT+09:00)"},
      {value: "Tokyo (GMT+09:00)", label: "Tokyo (GMT+09:00)"},
      {value: "Yakutsk (GMT+09:00)", label: "Yakutsk (GMT+09:00)"},
      {value: "Adelaide (GMT+09:30)", label: "Adelaide (GMT+09:30)"},
      {value: "Darwin (GMT+09:30)", label: "Darwin (GMT+09:30)"},
      {value: "Brisbane (GMT+10:00)", label: "Brisbane (GMT+10:00)"},
      {value: "Canberra (GMT+10:00)", label: "Canberra (GMT+10:00)"},
      {value: "Guam (GMT+10:00)", label: "Guam (GMT+10:00)"},
      {value: "Hobart (GMT+10:00)", label: "Hobart (GMT+10:00)"},
      {value: "Melbourne (GMT+10:00)", label: "Melbourne (GMT+10:00)"},
      {value: "Port Moresby (GMT+10:00)", label: "Port Moresby (GMT+10:00)"},
      {value: "Sydney (GMT+10:00)", label: "Sydney (GMT+10:00)"},
      {value: "Vladivostok (GMT+10:00)", label: "Vladivostok (GMT+10:00)"},
      {value: "Magadan (GMT+11:00)", label: "Magadan (GMT+11:00)"},
      {value: "New Caledonia (GMT+11:00)", label: "New Caledonia (GMT+11:00)"},
      {value: "Solomon Is. (GMT+11:00)", label: "Solomon Is. (GMT+11:00)"},
      {value: "Srednekolymsk (GMT+11:00)", label: "Srednekolymsk (GMT+11:00)"},
      {value: "Auckland (GMT+12:00)", label: "Auckland (GMT+12:00)"},
      {value: "Fiji (GMT+12:00)", label: "Fiji (GMT+12:00)"},
      {value: "Kamchatka (GMT+12:00)", label: "Kamchatka (GMT+12:00)"},
      {value: "Marshall Is. (GMT+12:00)", label: "Marshall Is. (GMT+12:00)"},
      {value: "Wellington (GMT+12:00)", label: "Wellington (GMT+12:00)"},
      {value: "Chatham Is. (GMT+12:45)", label: "Chatham Is. (GMT+12:45)"},
      {value: "Nuku'alofa (GMT+13:00)", label: "Nuku'alofa (GMT+13:00)"},
      {value: "Samoa (GMT+13:00)", label: "Samoa (GMT+13:00)"},
      {value: "Tokelau Is. (GMT+13:00)", label: "Tokelau Is. (GMT+13:00)"}
    ],
    comboModulos: [
      {value: modulos.BASICO, label: translateModulos[modulos.BASICO]},
      {value: modulos.INFORMES, label: translateModulos[modulos.INFORMES]},
      {value: modulos.PEDIDOS_CLIENTES, label: translateModulos[modulos.PEDIDOS_CLIENTES]},
      {value: modulos.TRAZABILIDAD_BIOSEGURIDAD, label: translateModulos[modulos.TRAZABILIDAD_BIOSEGURIDAD]},
      {value: modulos.APP, label: translateModulos[modulos.APP]}
    ],
    comboCustomizacion: [
      {value: 'PICTraq', label: 'PICTraq'},
      {value: 'USA', label: 'USA'},
      {value: 'Magapor', label: 'Magapor'},
      {value: 'AgView', label: 'AgView'},
      {value: 'ITM', label: 'ITM'},
      {value: 'DataSwine', label: 'DataSwine'},
      {value: 'AbuelosBagmatic', label: 'AbuelosBagmatic'},
      {value: 'Netpork', label: 'Netpork'},
      {value: 'Bretanha', label: 'Bretanha'},
      {value: 'PICFilipinas', label: 'PICFilipinas'},
      {value: 'PICCanada', label: 'PICCanada'},
      {value: 'Ciaro', label: 'Ciaro'},
      {value: 'Tradiporc', label: 'Tradiporc'}
    ],
    comboAgrupacion: [
      {value: 1, label: 'COMUN.COMBOS.AGRUPACION.VERRACO'},
      {value: 2, label: 'COMUN.COMBOS.AGRUPACION.RAZA'},
      {value: 3, label: 'COMUN.COMBOS.AGRUPACION.LINEA_GENETICA'}
    ],
    comboNombreGrupoVerracoActiva: [],
    comboTodasUbicaciones: [],
    comboRutasActivas: [],
    comboVigenteActual: [
      {value: 1, label: 'COMUN.COMBOS.VIGENTE_ACTUAL.TODOS'},
      {value: 2, label: 'COMUN.COMBOS.VIGENTE_ACTUAL.VIGENTE_ACTUAL'}
    ],
    comboInstalacionesPadreOSinHijos: [],
    comboPendienteEncursoTerminado: [
      {value: 1, label: 'COMUN.COMBOS.COMBO_PENDIENTE_ENCURSO_TERMINADO.PENDIENTES'},
      {value: 2, label: 'COMUN.COMBOS.COMBO_PENDIENTE_ENCURSO_TERMINADO.EN_CURSO'},
      {value: 3, label: 'COMUN.COMBOS.COMBO_PENDIENTE_ENCURSO_TERMINADO.TERMINADO'}
    ],
    comboVerracoPrevisto: [
      {value: 1, label: 'COMUN.COMBOS.VERRACOS_PREVISTOS.VERRACOS_PLANING'},
      {value: 2, label: 'COMUN.COMBOS.VERRACOS_PREVISTOS.TODOS'}
    ],
    comboVerracoConSeguimiento: [],
    comboDireccionesClienteSinPredeterminado: [],
    comboRazaGranja: [],
    comboLineaGeneticaGranja: [],
    comboTipoDosisGranja: [],
    comboNivelGenetico: [],
    comboNivelGeneticoGeneral: [],
    comboNivelGeneticoActivo: [],
    comboNivelGeneticoActivoGranja: [],
    comboTipoControlSangre: [
      {value: 1, label: 'COMUN.COMBOS.CONTROL_SANGRE.RUTINARIO'},
      {value: 2, label: 'COMUN.COMBOS.CONTROL_SANGRE.DIRIGIDO'}
    ],
    comboTipoControlSemen: [
      {value: 1, label: 'COMUN.COMBOS.CONTROL_SANGRE.RUTINARIO'},
      {value: 2, label: 'COMUN.COMBOS.CONTROL_SANGRE.DIRIGIDO'}
    ],
    comboResultadoControlSangre: [    
      {value: 1, label: 'COMUN.COMBOS.RESULTADO.POSITIVO'},
      {value: 2, label: 'COMUN.COMBOS.RESULTADO.NEGATIVO'},
      {value: 3, label: 'COMUN.COMBOS.RESULTADO.DUDOSO'}      
    ],
    comboResultadoControlSemen: [    
      {value: 1, label: 'COMUN.COMBOS.RESULTADO.POSITIVO'},
      {value: 2, label: 'COMUN.COMBOS.RESULTADO.NEGATIVO'},
      {value: 3, label: 'COMUN.COMBOS.RESULTADO.DUDOSO'}      
    ], 
    comboTipoMicrobiologia: [
      { value: 1, label: 'COMUN.COMBOS.MICROBIOLOGIA.DOSIS' },
      { value: 2, label: 'COMUN.COMBOS.MICROBIOLOGIA.DILUYENTE' },
      { value: 3, label: 'COMUN.COMBOS.MICROBIOLOGIA.PURO' },
      { value: 4, label: 'COMUN.COMBOS.MICROBIOLOGIA.AGUA' }         
    ],
    comboAntibioticoMicrobiologia: [
      { value: 1, label: 'S' },
      { value: 2, label: 'R' },
    ]   
  }
}

function comboCodLineaGeneticaSuccess (state, {data}) {
  return {
    ...state,
    comboCodLineaGenetica: data
  }
}

function comboLineaGeneticaSuccess (state, {data}) {
  return {
    ...state,
    comboLineaGenetica: data
  }
}

function comboCodRazaSuccess (state, {data}) {
  return {
    ...state,
    comboCodRaza: data
  }
}

function comboRazaSuccess (state, {data}) {
  return {
    ...state,
    comboRaza: data
  }
}

function comboNombreGrupoVerracoSuccess (state, {data}) {
  return {
    ...state,
    comboNombreGrupoVerraco: data
  }
}

function comboVerracoSuccess (state, {data}) {
  return {
    ...state,
    comboVerraco: data
  }
}

function comboTipoInstalacionPadreSuccess (state, {data}) {
  return {
    ...state,
    comboTipoInstalacionPadre: data
  }
}

function comboTipoInstalacionSuccess (state, {data}) {
  return {
    ...state,
    comboTipoInstalacion: data
  }
}

function comboInstalacionPadreSuccess (state, {data}) {
  return {
    ...state,
    comboInstalacionPadre: data
  }
}

function comboCodInstalacionSuccess (state, {data}) {
  return {
    ...state,
    comboCodInstalacion: data
  }
}

function comboNombreInstalacionSuccess (state, {data}) {
  return {
    ...state,
    comboNombreInstalacion: data
  }
}

function comboOperarioSuccess (state, {data}) {
  return {
    ...state,
    comboOperario: data
  }
}

function comboSalaExtraccionSuccess (state, {data}) {
  return {
    ...state,
    comboSalaExtraccion: data
  }
}

function comboClienteSuccess (state, {data}) {
  return {
    ...state,
    comboCliente: data
  }
}

function comboDireccionClienteSuccess (state, {data}) {
  return {
    ...state,
    comboDireccionCliente: data
  }
}

function comboDireccionClienteSecundariaSuccess (state, {data}) {
  return {
    ...state,
    comboDireccionClienteSecundaria: data
  }
}

function ubicacionenesVaciasSuccess (state, {data}) {
  return {
    ...state,
    comboUbicacionVacia: data
  }
}

function comboUbicacionSuccess (state, {data}) {
  return {
    ...state,
    comboUbicacion: data
  }
}

function comboTipoDosisSuccess (state, {data}) {
  return {
    ...state,
    comboTipoDosis: data
  }
}

function comboObtenerCentroUsuarioSuccess (state, {data}) {
  return {
    ...state,
    comboObtenerCentroUsuario: data
  }
}

function comboListadoVerracosSuccess (state, {data}) {
  return {
    ...state,
    comboListadoVerracos: data
  }
}

function comboObservacionesEyaculadoEliminadoSuccess (state, {data}) {
  return {
    ...state,
    comboObservacionesEyaculadoEliminado: data
  }
}

function comboCausaEliminacionSuccess (state, {data}) {
  return {
    ...state,
    comboCausaEliminacion: data
  }
}

function fetchComboPoolSuccess (state, {data}) {
  return {
    ...state,
    comboPool: data
  }
}

function fetchComboTipoDiluyenteSuccess (state, {data}) {
  return {
    ...state,
    comboTipoDiluyente: data
  }
}

function fetchComboProductoSuccess (state, {data}) {
  return {
    ...state,
    comboProducto: data
  }
}

function comboTipoAlimentacionSuccess (state, {data}) {
  return {
    ...state,
    comboTipoAlimentacion: data
  }
}

function comboTipoIntervencionSanitariaSuccess (state, {data}) {
  return {
    ...state,
    comboTipoIntervencionSanitaria: data
  }
}

function comboVerracoSinUbicacionSuccess (state, {data}){
  return{
    ...state,
    comboVerracoSinUbicacion: data
  }
}

function comboMaquinaSuccess (state, {data}){
  return{
    ...state,
    comboMaquina: data
  }
}

function comboRutaSuccess (state, {data}){
  return{
    ...state,
    comboRuta: data
  }
}

function comboRutasActivasSuccess (state, {data}){
  return{
    ...state,
    comboRuta: data
  }
}

function comboCifClienteSuccess (state, {data}){
  return{
    ...state,
    comboCifCliente: data
  }
}

function comboLocalidadClienteSuccess (state, {data}){
  return{
    ...state,
    comboLocalidadCliente: data
  }
}

function comboInstalacionesPadreSuccess (state, {data}){
  return{
    ...state,
    comboInstalacionesPadre: data
  }
}

function comboNombresOperariosSuccess (state, {data}){
  return{
    ...state,
    comboNombresOperarios: data
  }
}

function comboApellidosOperariosSuccess (state, {data}){
  return{
    ...state,
    comboApellidosOperarios: data
  }
}

function comboLocalidadOperariosSuccess (state, {data}){
  return{
    ...state,
    comboLocalidadOperarios: data
  }
}

function comboEmpresaVisitasSuccess (state, {data}){
  return{
    ...state,
    comboEmpresaVisitas: data
  }
}

function comboContactoVistasSuccess (state, {data}){
  return{
    ...state,
    comboContactoVistas: data
  }
}

function comboLineaGeneticaActivaSuccess (state, {data}){
  return{
    ...state,
    comboLineaGeneticaActiva: data
  }
}

function comboRazaActivaSuccess (state, {data}){
  return{
    ...state,
    comboRazaActiva: data
  }
}

function comboOperarioActivoSuccess (state, {data}){
  return{
    ...state,
    comboOperarioActivo: data
  }
}

function comboSalaExtraccionActivoSuccess (state, {data}){
  return{
    ...state,
    comboSalaExtraccionActivo: data
  }
}

function fetchComboRectaCalibradoSuccess (state, {data}){
  return{
    ...state,
    comboRectaCalibrado: data
  }
}

function comboEmpresaTransportistaSuccess (state, {data}){
  return{
    ...state,
    comboEmpresaTransportista: data
  }
}
function comboConductoresTransportistaSuccess (state, {data}){
  return{
    ...state,
    comboConductoresTransportista: data
  }
}
function comboVehiculosTransportistaSuccess (state, {data}){
  return{
    ...state,
    comboVehiculosTransportista: data
  }
}
function comboUsuariosCentroSuccess (state, {data}){
  return{
    ...state,
    comboUsuariosCentro: data
  }
}
function comboGrupoUsuariosCentroSuccess (state, {data}){
  return{
    ...state,
    comboGrupoUsuariosCentro: data
  }
}

function comboNombreProductosSuccess (state, {data}){
  return{
    ...state,
    comboNombreProductos: data
  }
}

function comboReferenciaProductosSuccess (state, {data}){
  return{
    ...state,
    comboReferenciaProductos: data
  }
}

function comboNombreEscandalloSuccess (state, {data}){
  return{
    ...state,
    comboNombreEscandallo: data
  }
}

function comboProductoEscandalloSuccess (state, {data}){
  return{
    ...state,
    comboProductoEscandallo: data
  }
}

function comboProveedoresEntradaMercanciaSuccess (state, {data}){
  return{
    ...state,
    comboProveedoresEntradaMercancia: data
  }
}

function comboAlbaranesEntradaMercanciaSuccess (state, {data}){
  return{
    ...state,
    comboAlbaranesEntradaMercancia: data
  }
}

function comboOrigenesEntradaMercanciaSuccess (state, {data}){
  return{
    ...state,
    comboOrigenesEntradaMercancia: data
  }
}

function comboLotesSuccess (state, {data}){
  return{
    ...state,
    comboLotes: data
  }
}

function comboLotesActivosSuccess (state, {data}){
  return{
    ...state,
    comboLotesActivos: data
  }
}

function comboProductosActivosSuccess (state, {data}){
  return{
    ...state,
    comboProductosActivos: data
  }
}

function comboProductosActivosTrazabilidadSuccess (state, {data}){
  return{
    ...state,
    comboProductosActivosTrazabilidad: data
  }
}

function comboLotesProductoEspecificoActivoSuccess (state, {data}){
  return{
    ...state,
    comboLotesProductoEspecificoActivo: data
  }
}

function comboLotesProductoEspecificoActivoTrazabilidadSuccess (state, {data}){
  return{
    ...state,
    comboLotesProductoEspecificoActivoTrazabilidad: data
  }
}

function comboRazonSocialClientesActivosSuccess (state, {data}){
  return{
    ...state,
    comboRazonSocialClientesActivos: data
  }
}

function comboAliasClientesActivosSuccess (state, {data}){
  return{
    ...state,
    comboAliasClientesActivos: data
  }
}

function comboIndexSuccess (state, {data}){
  return{
    ...state,
    comboIndex: data
  }
}

function comboUbicacionPadreSuccess (state, {data}){
  return{
    ...state,
    comboUbicacionPadre: data
  }
}

function comboVerracosPresentesActivosSuccess (state, {data}){
  return{
    ...state,    
    comboVerracosPresentesActivos: data
  }
}

function comboVerracosExtraccionAlbaranSuccess (state, {data}){
  return{
    ...state,
    comboVerracosExtraccionAlbaran: data
  }
}

function comboPoolsExtraccionAlbaranSuccess (state, {data}){
  return{
    ...state,
    comboPoolsExtraccionAlbaran: data
  }
}
function comboClienteActivoSuccess (state, {data}){
  return{
    ...state,
    comboClienteActivo: data
  }
}
function comboClienteSecundarioActivoSuccess (state, {data}){
  return{
    ...state,
    comboClienteSecundarioActivo: data
  }
}
function comboDireccionClienteActivoSuccess (state, {data}){
  return{
    ...state,
    comboDireccionClienteActivo: data
  }
}
function comboClienteConVerracosEnPropiedadSuccess (state, {data}){
  return{
    ...state,
    comboClienteConVerracosEnPropiedad: data
  }
}

function comboNumeroPedidoSuccess (state, {data}){
  return{
    ...state,
    comboNumeroPedido: data
  }
}

function comboTransportistasClienteSuccess (state, {data}){
  return{
    ...state,
    comboTransportistasCliente: data
  }
}

function comboRutaTransportistaClienteSuccess (state, {data}){
  return{
    ...state,
    comboRutaTransportistaCliente: data
  }
}

function comboVehiculosTransportistaDeterminadoSuccess (state, {data}){
  return{
    ...state,
    comboVehiculosTransportistaDeterminado: data
  }
}

function comboConductoresTransportistaDeterminadoSuccess (state, {data}){
  return{
    ...state,
    comboConductoresTransportistaDeterminado: data
  }
}

function comboNumerosAlbaranSuccess (state, {data}){
  return{
    ...state,
    comboNumerosAlbaran: data
  }
}

function comboEmpresaTransportistaActivosSuccess (state, {data}){
  return{
    ...state,
    comboEmpresaTransportistaActivos: data
  }
}

function comboInstalacionPadreActivaSuccess (state, {data}) {
  return {
    ...state,
    comboInstalacionPadreActiva: data
  }
}

function comboFiltroVerracosLimpiezaSuccess (state, {data}) {
  return {
    ...state,
    comboFiltroVerracosLimpieza: data
  }
}

function comboLocalidadClientesSuccess (state, {data}) {
  return {
    ...state,
    comboLocalidadClientes: data
  }
}

function comboProvinciasClientesSuccess (state, {data}) {
  return {
    ...state,
    comboProvinciasClientes: data
  }
}

function comboUsuariosNoAsignadosOperarioSuccess (state, {data}) {
  return {
    ...state,
    comboUsuariosNoAsignadosOperario: data
  }
}

function comboOperarioPredeterminadoSuccess (state, {data}) {
  return {
    ...state,
    comboOperarioPredeterminado: data
  }
}

function comboProductosValidacionActivosSuccess (state, {data}) {
  return {
    ...state,
    comboProductosValidacionActivos: data
  }
}

function comboNombreGrupoVerracoActivaSuccess (state, {data}) {
  return {
    ...state,
    comboNombreGrupoVerracoActiva: data
  }
}

function comboTodasUbicacionesSuccess (state, {data}) {
  return {
    ...state,
    comboTodasUbicaciones: data
  }
}

function comboInstalacionesPadreOSinHijosSuccess (state, {data}) {
  return {
    ...state,
    comboInstalacionesPadreOSinHijos: data
  }
}

function comboVerracoConSeguimientoSuccess (state, {data}) {
  return {
    ...state,
    comboVerracoConSeguimiento: data
  }
}

function comboDireccionesClienteSinPredeterminadoSuccess (state, {data}) {
  return {
    ...state,
    comboDireccionesClienteSinPredeterminado: data
  }
}

function comboRazaGranjaSuccess (state, {data}) {
  return {
    ...state,
    comboRazaGranja: data
  }
}

function comboLineaGeneticaGranjaSuccess (state, {data}) {
  return {
    ...state,
    comboLineaGeneticaGranja: data
  }
}

function comboTipoDosisGranjaSuccess (state, {data}) {
  return {
    ...state,
    comboTipoDosisGranja: data
  }
}

function comboNivelGeneticoSuccess (state, {data}) {
  return {
    ...state,
    comboNivelGenetico: data
  }
}

function comboNivelGeneticoGeneralSuccess (state, {data}) {
  return {
    ...state,
    comboNivelGeneticoGeneral: data
  }
}

function comboNivelGeneticoActivoSuccess (state, {data}) {
  return {
    ...state,
    comboNivelGeneticoActivo: data
  }
}

function comboNivelGeneticoActivoGranjaSuccess (state, {data}) {
  return {
    ...state,
    comboNivelGeneticoActivoGranja: data
  }
}

function comboCodPoolSuccess (state, {data}) {
  return {
    ...state,
    comboCodPool: data
  }
}


export default function (state = initialState(), action) {
  switch (action.type) {
    case combosActionTypes.COMBO_TODAS_UBICACIONES_SUCCESS:
      return comboTodasUbicacionesSuccess(state, action)
    case combosActionTypes.COMBO_COD_LINEA_GENETICA_SUCCESS:
      return comboCodLineaGeneticaSuccess(state, action)
    case combosActionTypes.COMBO_LINEA_GENETICA_SUCCESS:
      return comboLineaGeneticaSuccess(state, action)
    case combosActionTypes.COMBO_COD_RAZA_SUCCESS:
      return comboCodRazaSuccess(state, action)
    case combosActionTypes.COMBO_RAZA_SUCCESS:
      return comboRazaSuccess(state, action)
    case combosActionTypes.COMBO_NOMBRE_GRUPO_VERRACO_SUCCESS:
      return comboNombreGrupoVerracoSuccess(state, action)
    case combosActionTypes.COMBO_VERRACO_SUCCESS:
      return comboVerracoSuccess(state, action)
    case combosActionTypes.COMBO_TIPO_INSTALACION_PADRE_SUCCESS:
      return comboTipoInstalacionPadreSuccess(state, action)
    case combosActionTypes.COMBO_TIPO_INSTALACION_SUCCESS:
      return comboTipoInstalacionSuccess(state, action)
    case combosActionTypes.COMBO_INSTALACION_PADRE_SUCCESS:
      return comboInstalacionPadreSuccess(state, action)
    case combosActionTypes.COMBO_COD_INSTALACION_SUCCESS:
      return comboCodInstalacionSuccess(state, action)
    case combosActionTypes.COMBO_NOMBRE_INSTALACION_SUCCESS:
      return comboNombreInstalacionSuccess(state, action)
    case combosActionTypes.COMBO_OPERARIO_SUCCESS:
      return comboOperarioSuccess(state, action)
    case combosActionTypes.COMBO_SALA_EXTRACCION_SUCCESS:
      return comboSalaExtraccionSuccess(state, action)
    case combosActionTypes.COMBO_CLIENTE_SUCCESS:
      return comboClienteSuccess(state, action)
    case combosActionTypes.COMBO_DIRECCION_CLIENTE_SUCCESS:
      return comboDireccionClienteSuccess(state, action)
    case combosActionTypes.COMBO_DIRECCION_CLIENTE_SECUNDARIA_SUCCESS:
      return comboDireccionClienteSecundariaSuccess(state, action)
    case movimientoVerracoActionTypes.UBICACIONES_VACIAS_SUCCESS:
      return ubicacionenesVaciasSuccess(state, action)
    case combosActionTypes.COMBO_TIPO_DOSIS_SUCCESS:
      return comboTipoDosisSuccess(state, action)
    case combosActionTypes.COMBO_OBTENER_CENTRO_USUARIO_SUCCESS:
      return comboObtenerCentroUsuarioSuccess(state, action)
    case combosActionTypes.COMBO_LISTADO_VERRACO:
      return comboListadoVerracosSuccess(state, action)
    case combosActionTypes.COMBO_OBSERVACIONES_EYACULADO_ELIMINADO_SUCCESS:
      return comboObservacionesEyaculadoEliminadoSuccess(state, action)
    case combosActionTypes.COMBO_CAUSA_ELIMINACION_SUCCESS:
      return comboCausaEliminacionSuccess(state, action)
    case combosActionTypes.FETCH_COMBO_POOL_SUCCESS:
      return fetchComboPoolSuccess(state, action)
    case combosActionTypes.FETCH_COMBO_TIPO_DILUYENTE_SUCCESS:
      return fetchComboTipoDiluyenteSuccess(state, action)
    case combosActionTypes.FETCH_COMBO_PRODUCTO_SUCCESS:
      return fetchComboProductoSuccess(state, action)
    case combosActionTypes.COMBO_TIPO_ALIMENTACION_SUCCESS:
      return comboTipoAlimentacionSuccess(state, action)
    case combosActionTypes.COMBO_TIPO_INTERVENCION_SANITARIA_SUCCESS:
      return comboTipoIntervencionSanitariaSuccess(state, action)
    case combosActionTypes.COMBO_VERRACO_SIN_UBICACION_SUCCESS:
      return comboVerracoSinUbicacionSuccess(state, action)
    case combosActionTypes.COMBO_MAQUINA_SUCCESS:
      return comboMaquinaSuccess(state, action)
    case combosActionTypes.COMBO_RUTA_SUCCESS:
      return comboRutaSuccess(state, action)
    case combosActionTypes.COMBO_RUTAS_ACTIVAS_SUCCESS:
      return comboRutasActivasSuccess(state, action)
    case combosActionTypes.COMBO_CIF_CLIENTE_SUCCESS:
      return comboCifClienteSuccess(state, action)
    case combosActionTypes.COMBO_LOCALIDAD_CLIENTE_SUCCESS:
      return comboLocalidadClienteSuccess(state, action)
    case combosActionTypes.COMBO_INSTALACIONES_PADRE_SUCCESS:
      return comboInstalacionesPadreSuccess(state, action)
    case combosActionTypes.COMBO_NOMBRES_OPERARIOS_SUCCESS:
      return comboNombresOperariosSuccess(state, action)
    case combosActionTypes.COMBO_APELLIDOS_OPERARIOS_SUCCESS:
      return comboApellidosOperariosSuccess(state, action)
    case combosActionTypes.COMBO_LOCALIDAD_OPERARIOS_SUCCESS:
      return comboLocalidadOperariosSuccess(state, action)
    case combosActionTypes.COMBO_EMPRESA_VISITAS_SUCCESS:
      return comboEmpresaVisitasSuccess(state, action)
    case combosActionTypes.COMBO_CONTACTO_VISITAS_SUCCESS:
      return comboContactoVistasSuccess(state, action)
    case combosActionTypes.COMBO_LINEA_GENETICA_ACTIVA_SUCCESS:
      return comboLineaGeneticaActivaSuccess(state, action)
    case combosActionTypes.COMBO_RAZA_ACTIVA_SUCCESS:
      return comboRazaActivaSuccess(state, action)
    case combosActionTypes.COMBO_OPERARIO_ACTIVO_SUCCESS:
      return comboOperarioActivoSuccess(state, action)
    case combosActionTypes.COMBO_SALA_EXTRACCION_ACTIVO_SUCCESS:
      return comboSalaExtraccionActivoSuccess(state, action)
    case combosActionTypes.FETCH_COMBO_RECTA_CALIBRADO_SUCCESS:
      return fetchComboRectaCalibradoSuccess(state, action)
    case combosActionTypes.COMBO_EMPRESA_TRANSPORTISTA_SUCCESS:
      return comboEmpresaTransportistaSuccess(state, action)
    case combosActionTypes.COMBO_CONDUCTORES_TRANSPORTISTA_SUCCESS:
      return comboConductoresTransportistaSuccess(state, action)
    case combosActionTypes.COMBO_VEHICULO_TRANSPORTISTA_SUCCESS:
      return comboVehiculosTransportistaSuccess(state, action)
    case combosActionTypes.COMBO_USUARIOS_CENTRO_SUCCESS:
      return comboUsuariosCentroSuccess(state, action)
    case combosActionTypes.COMBO_GRUPO_USUARIOS_CENTRO_SUCCESS:
      return comboGrupoUsuariosCentroSuccess(state, action)
    case combosActionTypes.COMBO_NOMBRE_PRODUCTO_SUCCESS:
      return comboNombreProductosSuccess(state, action)
    case combosActionTypes.COMBO_REFERENCIA_PRODUCTO_SUCCESS:
      return comboReferenciaProductosSuccess(state, action)
    case combosActionTypes.COMBO_NOMBRE_ESCANDALLO_SUCCESS:
      return comboNombreEscandalloSuccess(state, action)
    case combosActionTypes.COMBO_PRODUCTO_ESCANDALLO_SUCCESS:
      return comboProductoEscandalloSuccess(state, action)
    case combosActionTypes.COMBO_PROVEEDORES_ENTRADA_MERCANCIA_SUCCESS:
      return comboProveedoresEntradaMercanciaSuccess(state, action)
    case combosActionTypes.COMBO_ORIGENES_ENTRADA_MERCANCIA_SUCCESS:
      return comboOrigenesEntradaMercanciaSuccess(state, action)
    case combosActionTypes.COMBO_ALBARANES_ENTRADA_MERCANCIA_SUCCESS:
      return comboAlbaranesEntradaMercanciaSuccess(state, action)
    case combosActionTypes.COMBO_LOTES_SUCCESS:
      return comboLotesSuccess(state, action)
    case combosActionTypes.COMBO_LOTES_ACTIVOS_SUCCESS:
      return comboLotesActivosSuccess(state, action)
    case combosActionTypes.COMBO_PRODUCTOS_ACTIVOS_SUCCESS:
      return comboProductosActivosSuccess(state, action)
    case combosActionTypes.COMBO_PRODUCTOS_ACTIVOS_TRAZABILIDAD_SUCCESS:
      return comboProductosActivosTrazabilidadSuccess(state, action)
    case combosActionTypes.COMBO_LOTES_PRODUCTO_ESPECIFICO_ACTIVO_SUCCESS:
      return comboLotesProductoEspecificoActivoSuccess(state, action)
    case combosActionTypes.COMBO_LOTES_PRODUCTO_ESPECIFICO_ACTIVO_TRAZABILIDAD_SUCCESS:
      return comboLotesProductoEspecificoActivoTrazabilidadSuccess(state, action)
    case combosActionTypes.COMBO_RAZON_SOCIAL_CLIENTES_ACTIVOS_SUCCESS:
      return comboRazonSocialClientesActivosSuccess(state, action)
    case combosActionTypes.COMBO_ALIAS_CLIENTES_ACTIVOS_SUCCESS:
      return comboAliasClientesActivosSuccess(state, action)
    case combosActionTypes.COMBO_INDEX_SUCCESS:
      return comboIndexSuccess(state, action)
    case combosActionTypes.COMBO_UBICACION_PADRE_SUCCESS:
      return comboUbicacionPadreSuccess(state, action)
    case combosActionTypes.COMBO_UBICACION_SUCCESS:
      return comboUbicacionSuccess(state, action)
    case combosActionTypes.COMBO_VERRACOS_PRESENTES_ACTIVOS_SUCCESS:
      return comboVerracosPresentesActivosSuccess(state, action)
    case combosActionTypes.COMBO_VERRACOS_EXTRACCION_ALBARAN_SUCCESS:
      return comboVerracosExtraccionAlbaranSuccess(state, action)
    case combosActionTypes.COMBO_POOLS_EXTRACCION_ALBARAN_SUCCESS:
      return comboPoolsExtraccionAlbaranSuccess(state, action)
    case combosActionTypes.COMBO_CLIENTE_ACTIVO_SUCCESS:
      return comboClienteActivoSuccess(state, action)
    case combosActionTypes.COMBO_CLIENTE_SECUNDARIO_ACTIVO_SUCCESS:
      return comboClienteSecundarioActivoSuccess(state, action)
    case combosActionTypes.COMBO_DIRECCION_CLIENTE_ACTIVO_SUCCESS:
      return comboDireccionClienteActivoSuccess(state, action)
    case combosActionTypes.COMBO_CLIENTE_CON_VERRACOS_EN_PROPIEDAD_SUCCESS:
      return comboClienteConVerracosEnPropiedadSuccess(state, action)
    case combosActionTypes.COMBO_NUMERO_PEDIDO_SUCCESS:
      return comboNumeroPedidoSuccess(state, action)
    case combosActionTypes.COMBO_TRANSPORTISTAS_CLIENTE_SUCCESS:
      return comboTransportistasClienteSuccess(state, action)
    case combosActionTypes.COMBO_RUTA_TRANSPORTISTA_CLIENTE_SUCCESS:
      return comboRutaTransportistaClienteSuccess(state, action)
    case combosActionTypes.COMBO_VEHICULOS_TRANSPORTISTA_DETERMINADO_SUCCESS:
      return comboVehiculosTransportistaDeterminadoSuccess(state, action)
    case combosActionTypes.COMBO_CONDUCTORES_TRANSPORTISTA_DETERMINADO_SUCCESS:
      return comboConductoresTransportistaDeterminadoSuccess(state, action)
    case combosActionTypes.COMBO_NUMEROS_ALBARAN_SUCCESS:
      return comboNumerosAlbaranSuccess(state, action)
    case combosActionTypes.COMBO_EMPRESA_TRANSPORTISTA_ACTIVOS_SUCCESS:
      return comboEmpresaTransportistaActivosSuccess(state, action)
    case combosActionTypes.COMBO_INSTALACION_PADRE_ACTIVA_SUCCESS:
      return comboInstalacionPadreActivaSuccess(state, action)
    case combosActionTypes.COMBO_FILTRO_VERRACOS_LIMPIEZA_SUCCESS:
      return comboFiltroVerracosLimpiezaSuccess(state, action)
    case combosActionTypes.COMBO_LOCALIDAD_CLIENTES_SUCCESS:
      return comboLocalidadClientesSuccess(state, action)
    case combosActionTypes.COMBO_PROVINCIAS_CLIENTES_SUCCESS:
      return comboProvinciasClientesSuccess(state, action)
    case combosActionTypes.COMBO_USUARIOS_NO_ASIGNADOS_OPERARIO_SUCCESS:
      return comboUsuariosNoAsignadosOperarioSuccess(state, action)
    case combosActionTypes.COMBO_OPERARIO_PREDETERMINADO_SUCCESS:
      return comboOperarioPredeterminadoSuccess(state, action)
    case combosActionTypes.COMBO_PRODUCTOS_VALIDACION_ACTIVOS_SUCCESS:
      return comboProductosValidacionActivosSuccess(state, action)
    case combosActionTypes.COMBO_NOMBRE_GRUPO_VERRACO_ACTIVA_SUCCESS:
      return comboNombreGrupoVerracoActivaSuccess(state, action)
    case combosActionTypes.COMBO_INSTALACIONES_PADRE_O_SIN_HIJOS_SUCCESS:
      return comboInstalacionesPadreOSinHijosSuccess(state, action)
    case combosActionTypes.COMBO_VERRACOS_CON_SEGUIMIENTO_SUCCESS:
      return comboVerracoConSeguimientoSuccess(state, action)
    case combosActionTypes.COMBO_DIRECCION_CLIENTE_SIN_PERSONALIZADO_SUCCESS:
      return comboDireccionesClienteSinPredeterminadoSuccess(state, action)
    case combosActionTypes.COMBO_RAZA_GRANJA_SUCCESS:
      return comboRazaGranjaSuccess(state, action)
    case combosActionTypes.COMBO_LINEA_GENETICA_GRANJA_SUCCESS:
      return comboLineaGeneticaGranjaSuccess(state, action)
    case combosActionTypes.COMBO_TIPO_DOSIS_GRANJA_SUCCESS:
      return comboTipoDosisGranjaSuccess(state, action)
    case combosActionTypes.COMBO_NIVEL_GENETICO_SUCCESS:
      return comboNivelGeneticoSuccess(state, action)
    case combosActionTypes.COMBO_NIVEL_GENETICO_GENERAL_SUCCESS:
      return comboNivelGeneticoGeneralSuccess(state, action)
    case combosActionTypes.COMBO_NIVEL_GENETICO_ACTIVO_SUCCESS:
      return comboNivelGeneticoActivoSuccess(state, action)
    case combosActionTypes.COMBO_NIVEL_GENETICO_ACTIVO_GRANJA_SUCCESS:
      return comboNivelGeneticoActivoGranjaSuccess(state, action)
    case combosActionTypes.COMBO_COD_POOL_SUCCESS:
        return comboCodPoolSuccess(state, action)
    default:
      return state
  }
}
